import React, { useState } from 'react';

export default function CopyField({ value, label }) {
  const [copied, setCopied] = useState(false);

  function copy() {
    if (!value) return;
    try {
      navigator.clipboard.writeText(String(value)).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1400);
      });
    } catch (_e) {
      const ta = document.createElement('textarea');
      ta.value = String(value);
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); setCopied(true); setTimeout(() => setCopied(false), 1400); } catch (_e2) {}
      document.body.removeChild(ta);
    }
  }
  return (
    <div className="input-suffix">
      {label && <label>{label}</label>}
      <input className="input" value={value || ''} readOnly onFocus={e => e.target.select()} />
      <button className="btn btn-ghost btn-sm" onClick={copy} style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)' }}>
        {copied ? 'Copied' : 'Copy'}
      </button>
    </div>
  );
}
